export default "__VITE_ASSET__C9SBc6EL__"